import man from '../public/assets/images/man.svg'
export default function ManPerfectImg() {
    return (
        <img className="success_perfect__image" src={man} alt="success" />
    )
}
